import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/BusDist/index",
  name: "BusDistIndex",
  component: function component() {
    return import("../../../views/dev-plug/business-district/index.vue");
  },
  meta: {
    foot: true
  }
}, {
  path: "/BusDist/home/:identity",
  name: "BusDistHome",
  component: function component() {
    return import("../../../views/dev-plug/business-district/home.vue");
  },
  meta: {
    foot: true
  }
}, {
  path: "/BusDist/StaffMgmt/:identity",
  name: "BusDistStaffMgmt",
  component: function component() {
    return import("../../../views/dev-plug/business-district/StaffMgmt.vue");
  },
  meta: {
    foot: true
  }
}, {
  path: "/BusDist/store/apply",
  name: "BusDistStoreApply",
  component: function component() {
    return import("../../../views/dev-plug/business-district/storeApply.vue");
  },
  meta: {
    foot: true,
    title: "门店审核"
  }
}, {
  path: "/BusDist/store/applyDetails/:apply_id",
  name: "BusDistStApDet",
  component: function component() {
    return import("../../../views/dev-plug/business-district/storeDetails.vue");
  },
  meta: {
    foot: true,
    title: "门店申请详情"
  }
}];